import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Data Finance"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Data semua kegiatan finance di PT TKI")
  ])
], -1)
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = { class: "card-title align-items-start flex-column" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_7 = { class: "d-flex align-items-center position-right my-1" }
const _hoisted_8 = { class: "card-title align-items-start flex-column" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bolder fs-7 mb-1" }, "Semua Transaksi", -1)
const _hoisted_10 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_11 = { class: "card-title align-items-start flex-column" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bolder fs-7 mb-1" }, "Jatuh Tempo", -1)
const _hoisted_13 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_14 = { class: "card-title align-items-start flex-column" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bolder fs-7 mb-1" }, "Belum Bayar", -1)
const _hoisted_16 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_17 = { class: "card-title align-items-start flex-column" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bolder fs-7 mb-1" }, "Sudah Bayar", -1)
const _hoisted_19 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_20 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_21 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_22 = { class: "card-body py-3" }
const _hoisted_23 = { class: "table-responsive" }
const _hoisted_24 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Sekolah"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Sales Area"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Implementator"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "After Sales"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tagihan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Lunas"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Belum"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Note"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "text-center" }
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "row mt-5 mb-5" }
const _hoisted_47 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_48 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_49 = ["label", "value"]
const _hoisted_50 = { class: "p-3" }
const _hoisted_51 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_52 = { class: "pagination" }
const _hoisted_53 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/superadmin/add-finance-invoice'))),
            class: "btn btn-sm btn-primary"
          }, " Tambah ")
        ]),
        _hoisted_5,
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h3", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, "Rp. " + _toDisplayString(_ctx.totalInvoice), 1)
        ]),
        _createElementVNode("h3", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.minJtp), 1)
        ]),
        _createElementVNode("h3", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, "Rp. " + _toDisplayString(_ctx.totalUnPaid), 1)
        ]),
        _createElementVNode("h3", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("span", _hoisted_19, "Rp. " + _toDisplayString(_ctx.totalUnPaid), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control w-250px ps-15",
            placeholder: "Cari Nama",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
            onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
          }, null, 544), [
            [_vModelText, _ctx.name]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("table", _hoisted_24, [
          _hoisted_25,
          (_ctx.tableData.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_27, _toDisplayString(item.schoolName), 1),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(item.salesArea), 1),
                    _createElementVNode("td", _hoisted_29, _toDisplayString(item.implementator), 1),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(item.afterSales), 1),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(item.totalInvoice), 1),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(item.countInvoice), 1),
                    _createElementVNode("td", _hoisted_33, _toDisplayString(item.totalPaid), 1),
                    _createElementVNode("td", _hoisted_34, _toDisplayString(item.totalUnPaid), 1),
                    _createElementVNode("td", _hoisted_35, _toDisplayString(item.note), 1),
                    _createElementVNode("td", _hoisted_36, [
                      _createElementVNode("a", {
                        class: "symbol symbol-35px me-2",
                        "data-bs-toggle": "tooltip",
                        title: "Detail",
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (_ctx.$router.push('/superadmin/view-finance/' + item._id))
                      }, _hoisted_39, 8, _hoisted_37),
                      _createElementVNode("a", {
                        class: "symbol symbol-35px me-2",
                        "data-bs-toggle": "tooltip",
                        title: "Hapus",
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (_ctx.handleDelete(index, item))
                      }, _hoisted_42, 8, _hoisted_40)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_43, _hoisted_45))
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("select", {
                name: "kt_customers_table_length",
                class: "form-select form-select-sm form-select-solid",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paging.size) = $event)),
                placeholder: "Per page",
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changePageSize()))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, _hoisted_49))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.paging.size]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("ul", _hoisted_52, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                style: {"cursor":"pointer"},
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
              }, " Previous ")
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.range(1, _ctx.paging.totalPages), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["page-item", { active: _ctx.paging.page + 1 === item }]),
                key: item
              }, [
                (Math.abs(item - _ctx.paging.page) <= 2)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "page-link",
                      onClick: ($event: any) => (_ctx.changePage(item))
                    }, _toDisplayString(item), 9, _hoisted_53))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128)),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                style: {"cursor":"pointer"},
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
              }, " Next ")
            ], 2)
          ])
        ])
      ])
    ])
  ], 2))
}